import { render, staticRenderFns } from "./LianheSchoolDetail.vue?vue&type=template&id=2f38bf83&scoped=true"
import script from "./LianheSchoolDetail.vue?vue&type=script&lang=js"
export * from "./LianheSchoolDetail.vue?vue&type=script&lang=js"
import style0 from "./LianheSchoolDetail.vue?vue&type=style&index=0&id=2f38bf83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38bf83",
  null
  
)

export default component.exports